<template>
  <div>
    <Dialog
      :visible.sync="custSearchDialog1"
      :style="{ width: '800px', height: '100%', overflowY: 'auto' }"
      :modal="true"
      :closable="true"
      :closeOnEscape="true"
      header="Customer/Contact Selection"
      class="p-fluid"
      :maximizable="true"
    >
      <Message v-for="(msg, i) of messages" severity="info" :key="i">
        <span :class="{ 'rebate-banner-text': msg.isRebate }">{{ msg.text }}</span>
      </Message>

      <div v-if="step === 1">
        <template>
          <div class="row">
            <div class="col col-lg-7 col-md-6">
              <div class="p-inputgroup">
                <InputText
                  autofocus
                  id="searchBox"
                  v-model="searchtext"
                  placeholder="Search Account No, Customer Name, City/Town, Post Code, Telephone number"
                  @input="setupSearch"
                />
                <Button icon="pi pi-times p-mx-1" @click="closeSearch" />
              </div>
            </div>
            <div class="col col-lg-5 col-md-6">
              <div class="p-field-radiobutton">
                <RadioButton
                  id="city1"
                  name="selectionType"
                  value="0"
                  class="p-pb-5"
                  v-model="selectionType"
                />
                <label for="city1" class="p-pl-2">All Customers</label>
              </div>
              <div
                class="p-field-radiobutton"
                v-if="
                  $store.getters['auth/getMyProfile'] &&
                    $store.getters['auth/getMyProfile'].defRegion &&
                    $store.getters['auth/getMyProfile'].defRegion.regionName
                "
              >
                <RadioButton
                  id="city1"
                  name="selectionType"
                  value="1"
                  class="p-pb-5"
                  v-model="selectionType"
                />
                <label for="city1" class="p-pl-2">{{
                  $store.getters["auth/getMyProfile"] &&
                  $store.getters["auth/getMyProfile"].defRegion &&
                  $store.getters["auth/getMyProfile"].defRegion.regionName
                    ? $store.getters["auth/getMyProfile"].defRegion.regionName +
                      ""
                    : "No region"
                }}</label>
              </div>
              <div
                class="p-field-radiobutton"
                v-else-if="
                  $store.getters['auth/getMyProfile'] &&
                    $store.getters['auth/getMyProfile'].defBranch &&
                    $store.getters['auth/getMyProfile'].defBranch.id
                "
              >
                <RadioButton
                  id="city2"
                  name="selectionType"
                  value="2"
                  class="p-pb-2"
                  v-model="selectionType"
                />
                <label for="city2" class="p-pt-2">{{
                  $store.getters["auth/getMyProfile"] &&
                  $store.getters["auth/getMyProfile"].defBranch &&
                  $store.getters["auth/getMyProfile"].defBranch.branchName
                    ? $store.getters["auth/getMyProfile"].defBranch.branchName +
                      ""
                    : "No branch"
                }}</label>
              </div>
            </div>
          </div>

          <!--<Button icon="pi pi-check" class="p-button-success" style="margin-right: .5em"/>-->
        </template>

        <div style="height: 467px;">
          <DataTable
            :key="reloadCustomersTable"
            v-if="searchtext"
            :value="customers2"
            :selection.sync="selectedCustomers"
            @row-select="onRowSelect"
            dataKey="customerId"
            class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers p-my-4 setFullHeightChilds"
            :scrollable="true"
            scrollHeight="300px"
            :loading="loading"
            :lazy="true"
            :rows="40"
            :virtualScroll="true"
            :virtualRowHeight="45"
            @virtual-scroll="onVirtualScroll"
            :totalRecords="lazyTotalRecords"
            selectionMode="single"
          >
            <template #header>
              Customers
            </template>
            <!-- :paginator="true"
            :rows="5"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 25, 50]" -->

            <Column
              field="custCode"
              header="Cust Code"
              headerStyle="width: 5em; text-align: center"
            >
              <template #loading>
                <span class="loading-text"></span>
              </template>
            </Column>
            <Column
              field="custName"
              header="Cust Name"
              headerStyle="width: 12em; text-align: center;"
            >
              <template #loading>
                <span class="loading-text">loading</span>
              </template>
            </Column>
            <Column
              field="regionName"
              header="Region"
              headerStyle="width: 7em; text-align: center;"
            >
              <template #loading>
                <span class="loading-text">loading</span>
              </template>
            </Column>
            <Column
              field="address4"
              header="City/Town"
              headerStyle="width: 7em; text-align: center"
            >
              <template #loading>
                <span class="loading-text"></span>
              </template>
            </Column>
            <Column
              field="mainEmail"
              header="Email"
              headerStyle="width: 10em; text-align: center"
            >
              <template #loading>
                <span class="loading-text"></span>
              </template>
            </Column>
            <Column
              field="postCode"
              header="Post Code"
              headerStyle="width: 10em; text-align: center"
            >
              <template #loading>
                <span class="loading-text"></span>
              </template>
            </Column>
          </DataTable>

          <h6 v-else style="text-align:center; padding-top: 100px;">
            Please type some text in the search box.
          </h6>
        </div>
      </div>
      <div v-else>
        <Message
          v-if="selectedCustomer && selectedCustomer.customerId"
          severity="success"
        >
          Customer: {{ selectedCustomer.custName }}
        </Message>

        <Message v-else severity="error">
          Please select a customer first
        </Message>

        <div style="height: 467px;">
          <!-- <hr style="border: 1px solid black"/> -->
          <DataTable
            :key="contactsDataTable"
            id="contactsTable"
            ref="contactdt"
            v-if="contacts"
            :value="contacts"
            :selection.sync="selectedContact"
            :rowHover="true"
            :scrollable="true"
            @row-select="onContactRowSelect"
            scrollHeight="300px"
            selectionMode="single"
            dataKey="contactId"
            class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers p-my-4 setFullHeightChilds"
          >
            <template #header>
              Contacts
            </template>
            <template #empty>
              No contacts found for the selected customer.
            </template>
            <Column
              field="firstName"
              header="First Name"
              headerStyle="width: 8em; text-align: center;"
            >
              <template #body="slotProps">
                {{ slotProps.data.firstName }}
              </template>
            </Column>
            <Column
              field="lastName"
              header="Last Name"
              headerStyle="width: 8em; text-align: center"
            >
              <template #body="slotProps">
                {{ slotProps.data.lastName }}
              </template>
            </Column>
            <Column
              field="mobile"
              header="Mobile"
              headerStyle="width: 9em; text-align: center"
            >
              <template #body="slotProps">
                {{ slotProps.data.mobile }}
              </template>
            </Column>
            <Column
              field="email"
              header="Email"
              headerStyle="width: 13em; text-align: center"
            >
              <template #body="slotProps">
                {{ slotProps.data.email }}
              </template>
            </Column>
            <Column
              field="contactType"
              header="Job Title"
              headerStyle="width: 9em; text-align: center"
            >
              <template #body="slotProps">
                {{
                  slotProps.data.jobTitle
                    ? slotProps.data.jobTitle.jobTitleDesc
                    : ""
                }}
              </template>
            </Column>
            <Column
              field="department"
              header="Department"
              headerStyle="width: 13em; text-align: center"
            >
              <template #body="slotProps">
                {{ slotProps.data.email ? slotProps.data.email : "" }}
              </template>
            </Column>
          </DataTable>
        </div>
      </div>

      <template #footer>
        <Button
          v-if="!disabledStep"
          style="float: left;"
          label="<< Customers"
          class="p-button-info"
          @click="step = 1"
        />
        <Button
          v-if="!disabledStep"
          style="float: left;"
          label="Contacts >>"
          class="p-button-info"
          @click="step = 2"
        />
        <Button
          v-if="selectedCustomer && disabledStep !== 2 && step === 2"
          label="New Contact"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          style="width: auto"
          @click="openNewContact"
        />
        <Button
          v-if="step === 1"
          class="p-button-success p-mr-2"
          label="New Customer"
          @click="openNewCustomer"
          style="width: auto"
        />
        <Button
          class="p-button-success p-mr-2"
          label="Select"
          @click="select"
          style="width: auto"
          :disabled="
            !selectedCustomer || (isContactRequired && !selectedContact)
          "
        />
        <Button
          class="p-button-secondary p-mr-2"
          label="Cancel"
          @click="$emit('close')"
          style="width: auto"
        />
      </template>
    </Dialog>

    <Dialog
      :visible.sync="rebateDialogVisible"
      :modal="true"
      :closable="false"
      header="Customer notice"
      :style="{ width: '420px' }"
    >
      <p
        v-if="rebateDialogRebate"
        class="rebate-notice-rebate"
      >{{ rebateDialogRebate }}</p>
      <p
        v-if="rebateDialogGeneral"
        class="rebate-notice-general"
        :class="{ 'rebate-notice-spaced': rebateDialogRebate }"
      >{{ rebateDialogGeneral }}</p>
      <template #footer>
        <Button label="OK" icon="pi pi-check" @click="acknowledgeRebateNotice()" autofocus />
      </template>
    </Dialog>
  </div>
</template>
<script>
import CustomerService from "@/service/CustomerService";
import AppSettingsService from '@/service/AppSettingsService'
import { computeRebateMessageText, resolveEffectiveDisplayMode, computeGeneralMessageText } from '@/mbp/universalComponents/customer/rebateMessage'

export default {
  name: "CustomerSearchDialog",
  props: {
    custSearchDialog: {
      type: Boolean,
      required: true
    },
    disabledStep: {
      type: Number,
      required: false
    },
    preSelectedCustomer: {
      type: Object,
      required: false
    },
    isContactRequired: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      contactToEdit: {},
      messages: [],
      customers: [],
      contacts: [],
      regionalCustomers: null, //this would be default, if user selects it, the values would be copied to customers1, while chunks would be in customers2
      allCustomers: null, // if user selects it, the values would be copied to customers1, while chunks would be in customers2
      selectedCustomers: null,
      selectedCustomer: null,
      selectedContact: null,
      customer: {},
      lazyTotalRecords: 0,
      customers2: null,
      customers1: null,
      searchtext: "",
      contactToEdit: {},
      duplicateToSend: {},
      selectionType: null,
      step: 1,
      requesting: false,
      contactsDataTable1: 0,
      reloadCustomersTable1: 0,
      appSettingsService: new AppSettingsService(),
      globalRebateMode: 'label',    // fetched once
      globalDefaultMessage: '',     // fetched once
      rebateDialogVisible: false,
      rebateDialogRebate: "",
      rebateDialogGeneral: ""
    };
  },
  computed: {
    contactsDataTable: {
      set() {
        this.contactsDataTable1++;
      },
      get() {
        return "contactsDataTable-" + this.contactsDataTable1.toString();
      }
    },
    reloadCustomersTable: {
      set() {
        this.reloadCustomersTable1++;
      },
      get() {
        return "reloadCustomersTable-" + this.reloadCustomersTable1.toString();
      }
    },
    loading() {
      if (this.customers2 && this.customers2[0]) {
        return false;
      } else {
        if (this.requesting) {
          return true;
        } else {
          return false;
        }
      }
    },
    custSearchDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        if (this.custSearchDialog) {
          this.checkPreSelectedCustomer();
        }
        return this.custSearchDialog === true ? true : false;
      }
    },
    profile() {
      return this.$store.getters["auth/getMyProfile"];
    }
  },
  customerService: null,
  created() {
    this.customerService = new CustomerService();

    this.setSelection(this.profile);

    // fetch global rebate display mode (best-effort; defaults to 'label')
    this.appSettingsService.getSetting('rebateDisplayMode')
      .then(res => { if (res && res.settingValue) this.globalRebateMode = res.settingValue })
      .catch(() => { /* keep default 'label' */ })

    this.appSettingsService.getSetting('rebateDefaultMessage')
      .then(res => { if (res && res.settingValue) this.globalDefaultMessage = res.settingValue })
      .catch(() => {})
  },
  mounted() {
    let a = document.getElementById("searchBox");
    if (a) a.focus();
  },
  watch: {
    profile(val) {
      this.setSelection(val);
    },
    step(val) {
      setTimeout(() => {
        this.setTableHeight();
      }, 100);

      if (val === 2) {
        this.contactsDataTable++;
      }
    },
    preSelectedCustomer(val) {
      this.checkPreSelectedCustomer();
    },
    selectedCustomer(val) {
      this.selectedContact = null;

      if (val && val.customerId) {
        this.applyRebateNotice(val.customerId);
      }
    },
    customers2() {
      this.setTableHeight();
    },
    contacts() {
      setTimeout(() => {
        this.setTableHeight();
      }, 100);
    }
  },
  methods: {
    setTableHeight() {
      let table = document.getElementsByClassName("setFullHeightChilds");
      //

      if (table && table[0]) {
        table[0].children.forEach(child => {
          //
          if (child.className === "p-datatable-scrollable-wrapper") {
            child.style.height = "92%";

            child.children.forEach(grandChild => {
              //
              if (grandChild.className === "p-datatable-scrollable-view") {
                grandChild.style.height = "100%";

                grandChild.children.forEach(grandgrandChild => {
                  //
                  if (
                    grandgrandChild.className === "p-datatable-scrollable-body"
                  ) {
                    grandgrandChild.style.height = "100%";
                  }
                });
              }
            });
          }
        });
      }
    },
    setSelection(val) {
      if (val) {
        if (val.defRegion && val.defRegion.regionName) {
          this.selectionType = "1";
        } else if (val.defBranch && val.defBranch.id) {
          this.selectionType = "2";
        } else {
          this.selectionType = "0";
        }
      }
    },
    checkPreSelectedCustomer() {
      let a = document.getElementById("searchBox");
      if (a) a.focus();

      if (this.preSelectedCustomer && this.preSelectedCustomer.customerId) {
        this.searchtext = this.preSelectedCustomer.custName;
        this.customers2 = [this.preSelectedCustomer];
        this.selectedCustomer = this.preSelectedCustomer;
        if (this.disabledStep !== 2) {
          this.getCustomerContacts(this.preSelectedCustomer.customerId);
          this.step = 2;
        }
      }
    },
    setupDataTable(data) {
      this.customers1 = data;
      this.customers2 = data;

      this.customers2 = this.loadChunk(0, 40);
      this.lazyTotalRecords = this.customers1.length;

      if (
        this.preSelectedCustomer &&
        this.preSelectedCustomer.custCode &&
        this.preSelectedCustomer.custName &&
        this.preSelectedCustomer.address1 &&
        this.preSelectedCustomer.address2 &&
        this.preSelectedCustomer.address3 &&
        this.preSelectedCustomer.address4 &&
        this.preSelectedCustomer.phoneNo &&
        this.preSelectedCustomer.postCode
      ) {
        this.selectedCustomer = data.find(a => {
          if (
            a.custCode === this.preSelectedCustomer.custCode &&
            a.custName === this.preSelectedCustomer.custName &&
            a.address1 === this.preSelectedCustomer.address1 &&
            a.address2 === this.preSelectedCustomer.address2 &&
            a.address3 === this.preSelectedCustomer.address3 &&
            a.address4 === this.preSelectedCustomer.address4 &&
            a.phoneNo === this.preSelectedCustomer.phoneNo &&
            a.postCode === this.preSelectedCustomer.postCode
          ) {
            return a;
          }
        });
        this.step = 2;
      }
    },
    loadChunk(index, length) {
      if (this.customers1) {
        let chunk = [];
        for (let i = 0; i < length; i++) {
          chunk[i] = this.customers1[index + i];
        }
        return chunk;
      }
    },
    onVirtualScroll(event) {
      // if (!this.searchtext) {
      // setTimeout(() => {
      //last chunk
      if (event.first === this.lazyTotalRecords - 40)
        this.customers2 = this.loadChunk(event.first, 40);
      else this.customers2 = this.loadChunk(event.first, event.rows);
      // }, 250);
      // }
    },
    async getCustomerContacts(customerId) {
      this.contacts = await this.customerService.getCustomerContacts(
        customerId
      );
      if (this.disabledStep !== 2) this.step = 2;
      // let element_id = document.getElementById("contactsTable");
      // if (element_id) {
      //   element_id.scrollIntoView({ block: "start", inline: "start", behavior: "smooth" });
      // }
    },
    onRowSelect(event) {
      this.selectedCustomer = event.data;
      this.getCustomerContacts(event.data.customerId);
    },
    onContactRowSelect(event) {
      //
      this.selectedContact = event.data;
    },
    select() {
      this.$emit("select", {
        customer: this.selectedCustomer,
        contact: this.selectedContact,
        contacts: this.contacts
      });
      this.$emit("close");
    },
    setupSearch() {
      //

      if (this.searchtext) {
        this.customers1 = [];
        this.customers2 = [];

        this.requesting = true;

        if (
          this.selectionType === "1" &&
          this.profile &&
          this.profile.defRegion &&
          this.profile.defRegion.id
        ) {
          this.customersCustomSearchURL(
            `0/${this.profile.defRegion.id}/*`,
            this.searchtext
          );
        } else if (
          this.selectionType === "2" &&
          this.profile &&
          this.profile.defBranch &&
          this.profile.defBranch.id
        ) {
          this.customersCustomSearchURL(
            `${this.profile.defBranch.id}/0/*`,
            this.searchtext
          );
        } else {
          this.customersCustomSearchURL(`0/0/*`, this.searchtext);
        }
      }
    },
    customersCustomSearchURL(pathParams, searchText) {
      this.customerService
        .customersCustomSearchURL(pathParams, searchText)
        .then(response => {
          this.requesting = false;

          let b = "";
          if (response && response.config && response.config.url) {
            let responseData = JSON.parse(response.config.data);
            b = responseData.searchText;
            if (b === this.searchtext) {
              this.customers1 = response.data;
              this.lazyTotalRecords = this.customers1.length;
              this.customers2 = this.loadChunk(0, 40);
              this.reloadCustomersTable++;
            }
          } else {
            if (
              !this.customers1 ||
              (this.customers1 &&
                (this.customers1.length === 0 ||
                  response.data.length < this.customers1.length))
            ) {
              this.customers1 = response.data;
              this.lazyTotalRecords = this.customers1.length;
              this.customers2 = this.loadChunk(0, 40);
            }
          }
        })
        .catch(e => {
          this.requesting = false;

          if (e && e.response && e.response.status !== 200)
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while searching customers",
              life: 5000
            });
        });
    },
    closeSearch() {
      this.customers2 = [];
      this.setSelection(this.profile);
      this.searchtext = "";
    },
    openNewCustomer() {
      this.$emit("selectCustomer");
    },
    openNewContact() {
      this.contactToEdit = {};
      if (this.selectedCustomer) {
        this.contactToEdit.customerId = this.selectedCustomer.customerId;
        this.contactToEdit.address1 = this.selectedCustomer.address1;
        this.contactToEdit.address2 = this.selectedCustomer.address2;
        this.contactToEdit.address3 = this.selectedCustomer.address3;
        this.contactToEdit.address4 = this.selectedCustomer.address4;
        this.contactToEdit.postCode = this.selectedCustomer.postCode;
        // this.contactToEdit.country = this.selectedCustomer.country;
        this.contactToEdit.canEmail = true;
        this.contactToEdit.canCall = true;
        this.contactToEdit.canMail = true;
        this.contactToEdit.active = true;

        this.$emit("selectContact", {
          customer: this.selectedCustomer,
          contactToEdit: this.contactToEdit
        });
      }
    },
    async applyRebateNotice(customerId) {
      this.messages = [];
      let full;
      try {
        full = await this.customerService.getCustomerInfo(customerId);
      } catch (e) {
        return; // silently skip notice on fetch failure
      }
      const general = computeGeneralMessageText(full);
      const rebate = computeRebateMessageText(full, this.globalDefaultMessage);
      if (!rebate && !general) return;
      // Rebate always leads, then the general showMsg note. Either may be absent.
      if (rebate) this.messages.push({ text: rebate, isRebate: true });
      if (general) this.messages.push({ text: general, isRebate: false });
      // Always show the banner; additionally show a popup when popup is in effect
      // (per-customer override, else the global default). The banner remains after
      // the popup is dismissed.
      const mode = resolveEffectiveDisplayMode(full, this.globalRebateMode);
      if (mode === "popup") {
        this.rebateDialogRebate = rebate;
        this.rebateDialogGeneral = general;
        this.rebateDialogVisible = true;
      }
    },
    acknowledgeRebateNotice() {
      this.rebateDialogVisible = false;
      this.rebateDialogRebate = "";
      this.rebateDialogGeneral = "";
    }
  }
};
</script>

<style scoped>
/* Rebate notice: the rebate line leads and is emphasised; in the popup it is
   red + bold, with a blank line before the general showMsg note. */
.rebate-notice-rebate {
  margin: 0;
  font-weight: 700;
  color: #d32f2f;
}

.rebate-notice-general {
  margin: 0;
}

.rebate-notice-spaced {
  margin-top: 1.2em;
}

.rebate-banner-text {
  font-weight: 700;
}

.p-datatable-scrollable {
  height: 100%;
}

.p-datatable-scrollable-wrapper {
  height: 100%;
}

.p-datatable-scrollable-view {
  height: 100%;
}

.p-datatable-scrollable-body {
  height: 100%;
}
</style>
